module.exports = __webpack_public_path__ + "img/19.70e75ba3.jpg";